import React from 'react';
import { Box } from '@mui/material';

const PromotionalVideoSection = () => (
  <Box
    sx={{
      alignItems: 'center',
      justifySelf: 'center', 
      width: '90%',
      paddingBottom: '30px',
      mt: { xs: -5, md: -20},
      mx: 'auto',
      display: 'flex', // Add this
      justifyContent: 'center', // And this
      '@media (min-height: 1080px)': {
        mt: -50
      },

      '@media (min-height: 900px)': {
        mt: -40
      },

      '@media (min-height: 768px)': {
        mt: -30
      },

      '@media (max-width: 600px)': {
        mt: -4,
      }

    }}
  >
    <Box
      sx={{
        position: 'relative',
        paddingBottom: '56.25%',
        width: '100%',
        height: 0,
        borderRadius: '40px',
        overflow: 'hidden', 
      }}
    >
      <video
        id="example-video"
        muted
        controls
        controlsList="nodownload"
        autoPlay
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          alignItems: 'center'
        }}
      >
        <source
          src="https://firebasestorage.googleapis.com/v0/b/bookaexcursion-36fb8.appspot.com/o/videos%2FBook%20A%20Excursion%20Website%20Reel.mp4?alt=media&token=b7c8c575-472d-474c-843b-0ef73f1f9652"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </Box>
  </Box>
);
export default PromotionalVideoSection;